import { asyncAction } from 'lib/actions';

export const fetchArtworkListAction = asyncAction('artwork/GET_LIST');
export const artworkAppendPageAction = asyncAction('artwork/APPEND_LIST');
